// extracted by mini-css-extract-plugin
module.exports = {"root":"entity-notice-google-picker-button_root__GlSrv","chip":"entity-notice-google-picker-button_chip__3Tcpn"};